import { useTranslation } from "react-i18next";

import { ConfirmActionButton } from "./ConfirmActionButton";

// TODO: Use this instead of buttons in other pages
interface SaveButtonProps {
  /** Async save handler; should return true on success */
  handleSave: () => Promise<boolean>;
  /** Optional button label, defaults to "Save" */
  buttonLabel?: string;
  /** Confirmation message, defaults to generic */
  confirmMessage?: string;
  /** If false, skips confirmation modal and saves immediately */
  requireConfirmation?: boolean;
  styleClasses?: string
  disabled?: boolean
}

export const SaveButton: React.FC<SaveButtonProps> = ({
  handleSave,
  buttonLabel,
  confirmMessage,
  requireConfirmation = true,
  styleClasses,
  disabled = false
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmActionButton
      onAction={handleSave}
      variant="success"
      actionLabel={t("actions.save")}
      mnemonic="s"
      confirmTitle={t("actions.confirmSave")}
      confirmMessage={confirmMessage ?? t("actions.confirmSaveMessage")}
      buttonLabel={buttonLabel ?? t("actions.save")}
      requireConfirmation={requireConfirmation}
      disabled={disabled}
      className={styleClasses}
    />
  );
};

export default SaveButton;
